// extracted by mini-css-extract-plugin
var _1 = "PointItem_content__7fb4a";
var _2 = "PointItem_root__7d957";
var _3 = "PointItem_time__2b98a";
var _4 = "PointItem_title__e0fd7";
export { _1 as "content", _2 as "root", _3 as "time", _4 as "title" }
